<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>done</v-icon>Validar solicitudes
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout>
              <v-flex xs6>
                <h4><strong>Listado de servidores publicos</strong></h4>
              </v-flex>
              <v-flex xs6>
                <v-menu open-on-hover buttom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card>
                    <v-card-text class="ayuda">
                      <v-layout>
                        <v-flex class="text-xs-center caption">
                          <strong>
                            <p><v-icon>help_outline</v-icon></p>
                            <p>Solo puede validar las programaciones</p>
                            <p>cuando todos los servidores públicos</p>
                            <p>del listado hayan enviado sus programaciones</p>
                          </strong>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="listado_funcionarios"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.servidor_publico }}</td>
                    <td class="text-xs-center">
                      <v-chip
                        dark
                        :color="
                          props.item.id_estado_vacac_progra == 22
                            ? '#9637FF'
                            : props.item.id_estado_vacac_progra == 51
                            ? '#00DB15'
                            : props.item.id_estado_vacac_progra == 73
                            ? '#7ee06a'
                            : props.item.id_estado_vacac_progra == 74
                            ? '#73b6c4'
                            : props.item.id_estado_vacac_progra == 72
                            ? '#9d20b6'
                            : props.item.id_estado_vacac_progra == 70
                            ? '#c267a5'
                            : props.item.id_estado_vacac_progra == 69
                            ? '#9aed65'
                            : props.item.id_estado_vacac_progra == 68
                            ? '#6f9eb8'
                             : props.item.id_estado_vacac_progra == 67
                            ? '#83e0e3'
                             : props.item.id_estado_vacac_progra == 66
                            ? '#b0bed6'
                             : props.item.id_estado_vacac_progra == 65
                            ? '#c267be'
                             : props.item.id_estado_vacac_progra == 54
                            ? '#8f66b8'
                             : props.item.id_estado_vacac_progra == 58
                            ? '#88a7f5'
                             : props.item.id_estado_vacac_progra == 57
                            ? '#7c73c3'
                             : props.item.id_estado_vacac_progra == 56
                            ? '#64a054'
                              : props.item.id_estado_vacac_progra == 55
                            ? '#19afb4'
                            : '#FF3400'
                        "
                        >
                        {{ props.item.estado }}
                         <!-- {{
                          props.item.id_estado_vacac_progra == 22
                            ? "Sin enviar"
                            :props.item.id_estado_vacac_progra == 66
                            ? "Enviado"
                            :props.item.id_estado_vacac_progra == 54
                            ? props.item.estado
                            : props.item.id_estado_vacac_progra == 51
                            ? "Enviado"
                            : "Rechazado"
                        }} -->
                        </v-chip
                      >
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            @click.prevent="validarProgramacion()"
            :disabled="!this.bandera_aprobacion"
            ><v-icon>done</v-icon>
            Validar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      headers: [
        { text: "Nombre", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ],
      bandera_aprobacion: true,
      user: this.$storage.get("user"),

    };
  },
  mounted() {
    this.$bus.$on("openDialogValidarProgramacionJefeJerarquicoNoDependencia", async () => {
      await this.cargarListadoFuncionario();
      this.dialog = true;
    });
  },

  methods: {

    async cargarListadoFuncionario() {
      let res =[]
        let contador_validados=0
         let contador_enviados=0
      try {

           res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${this.$route.params.id_unidad},${this.$route.params.gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });

          res = res.runQuery.respuesta;
          this.listado_funcionarios = res;

        this.listado_funcionarios.forEach(element => {
          // if (element.id_estado_vacac_progra == 22 || element.id_estado_vacac_progra == 47 || element.id_estado_vacac_progra == 73 || element.id_estado_vacac_progra == 51 || element.id_estado_vacac_progra == 74) {
          //   this.bandera_aprobacion = false;
          //   return;
          // }
        if (element.id_estado_vacac_progra ==74) {//validados
             contador_validados++
          }
          if (element.id_estado_vacac_progra ==66) {//enviados
             contador_enviados++
          }
        });
        if (contador_validados==this.listado_funcionarios.length || contador_enviados==0) {
          this.bandera_aprobacion = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogValidarProgramacionJefeJerarquicoNoDependencia");
      this.dialog = false;
    },
    async validarProgramacion() {
      let respuesta;
      let resps = [];
      let correcto = true;
      this.loading = true;
      let user = this.$storage.get("user");
   let bandera_correcto=true
   let mensaje_error=""
      try {
        for (let i = 0; i < this.listado_funcionarios.length; i++) {
          const element = this.listado_funcionarios[i];
          if (element.id_estado_vacac_progra==66) {
               respuesta = await this.$service.graphql({
                query: `
               
                query{
              runQuery(consulta:"select vacaciones.fn_valida_vacacion_programada_por_persona(${parseInt(this.$route.params.gestion)},${parseInt(element.id_persona)},74,${parseInt(user.id)})"){
                respuesta
              }
            }
                `
              });
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_valida_vacacion_programada_por_persona;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "0") {
                bandera_correcto=false
                mensaje_error=resps[1]
                //this.$message.success("La solicitud fue validada");
              } 
          }
        }
       if (bandera_correcto==true) {
         this.$message.success("Las solicitudes fueron validadas");
       } else {
          this.$message.success(mensaje_error);
       }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.close();
    }
  }
};
</script>

<style>
.ayuda {
  background: #7ae4db8f;
}


// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/ValidarProgramacionJefeJerarquicoNoDependencia.vue